module.exports = __webpack_public_path__ + "logo-team.svg?7a1113a1695299c488be8253852046bd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/logo-team.svg
// module id = 104
// module chunks = 0